const getVersion = (enablePaywallButtons?: boolean) => {
  let version = 'v2';
  if (enablePaywallButtons) {
    version = 'v2.1';
  }
  return version;
};
export default getVersion;
